export default defineNuxtPlugin(nuxtApp => {
  const dataAll = useDataAll()
  const { $analytics, $helpers,$apiMethods} = useNuxtApp()

  const headerMethods = {
    convertNewsEventvacancyHeader(headerObject) {
      return {
        MetaDescription: headerObject.MetaDescription,
        MetaTitle: headerObject.MetaTitle,
        MetaKeywords: headerObject.MetaKeywords,
        BrowserTitle: headerObject.BrowserTitle
      }
    },
    getCanonicalUrl(pageObject) {

      const route = useRoute()
      const url = useRequestURL()

      // let path = overridePath ?? route.path
      let path = route.path

      // Pad-filters: /filter/page_nr=2/s_article_application=trekken
      const [basePath, ...segments] = path.split('/filter/')

      if (segments.length > 0) {
        const kept = segments
          .join('/filter/')
          .split('/')
          .filter(seg => {
            const [key, value] = seg.split('=')
            if (key !== 'page_nr') return false
            return value !== '1'
          })

        path = kept.length > 0 ? `${basePath}/filter/${kept.join('/')}` : basePath
      }

      if (path.length > 1) {
        path = path.replace(/\/+$/, '')
      }

      // Query-parameters: ?page=2
      const params = new URLSearchParams()
      const page = route.query.page

      if (page && String(page) !== '1') {
        params.set('page', String(page))
      }

      const query = params.toString()

      return `https://${url.host}${path}${query ? '?' + query : ''}`
    },
    formatHeader(headerObject) {
      if (headerObject) {
        const { isIntranet } = useIntranetAuth()
        // const cookie_policy_accepted = useCookie("cookie_policy_accepted", {
        //   maxAge: 24 * 60 * 60 * 365,
        // });
        // const accesGranted = cookie_policy_accepted.value==1?true:false;
        const { public: config = {} } = useRuntimeConfig()
        const isDev = process.env.NODE_ENV !== 'production'
        const ALLOW_INDEXING_SEO = config.ALLOW_INDEXING_SEO || '0'
        const siteJson = useSiteSettingsStore();
        // let returnObject = [];
        // var titleTemplate = $helpers.isset(headerObject.TitelBrowser)?headerObject.TitelBrowser:$helpers.arrVal(headerObject, 'MetaTitle', "", " ");

        $analytics.addGMTToHeader(siteJson.TagManagerCode)

        const logoPath = '/PUBLIC/BINARY/FAVICON/' + $helpers.getLabelId() + "_" + dataAll.getLanguage().toUpperCase()

        let cssUrl = '/cache/CSS/custom_' + $helpers.getLabelId() + '_' + dataAll.getLanguage() + '.css'

        // Replace /cache with PUBLIC_DATA_URL in development environment to load CSS correctly from bucket
        if (isDev) {
          cssUrl = cssUrl.replace("/cache", config.PUBLIC_DATA_URL)
        }

        //public bucket not accesable for intranet so get css via API
        const cssPath = isIntranet()?
                              $apiMethods.getApiHostUrl() + "/api/" + $helpers.getLabelId() + "/css/"+dataAll.getLanguage()+"/custom.css"
                              :
                              cssUrl
        const canonical = headerMethods.getCanonicalUrl(headerObject)

        let returnObject = {
          titleTemplate: $helpers.isset(headerObject.BrowserTitle) ? headerObject.BrowserTitle : "",
          title: $helpers.isset(headerObject.MetaTitle) ? headerObject.MetaTitle : "",
          meta: [
            { charset: 'utf-8' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' },
            {
              hid: 'description',
              name: 'description',
              content: $helpers.isset(headerObject['MetaDescription']) ? headerObject['MetaDescription'] : "",
            },
            {
              hid: 'keywords',
              name: 'keywords',
              content: $helpers.isset(headerObject.MetaKeywords) ? headerObject.MetaKeywords : "",
            },
            // Robots meta tag based on env var NUXT_PUBLIC_ALLOW_INDEXING_SEO
            {
              hid: 'robots',
              name: 'robots',
              content: ALLOW_INDEXING_SEO == 1
                ? 'index, follow, max-snippet:-1, max-image-preview:large'
                : 'noindex, nofollow'
            }
          ],
          link: [
            canonical && { rel: 'canonical', href: canonical },
            {
              rel: 'icon',
              type: 'image/png',
              size: '32x32',
              href: logoPath + '/favicon-32x32.png',
            },
            {
              rel: 'icon',
              type: 'image/png',
              size: '16x16',
              href: logoPath + '/favicon-16x16.png',
            },
            {
              rel: 'shortcut icon',
              href: logoPath + '/favicon.ico',
            },
            {
              rel: 'apple-touch-icon',
              size: '180x180',
              href: logoPath + '/apple-touch-icon.png',
            },
            {
              rel: 'manifest',
              href: logoPath + '/site.webmanifest',
            },
            {
              rel: 'mask-icon',
              color: siteJson.Theme01Primary?siteJson.Theme01Primary:"#ffffff",
              href: logoPath + '/safari-pinned-tab.svg',
            },
            {
              rel: 'stylesheet',
              href: cssPath,
              tagPosition: 'bodyClose'
            },

          ]
        };
        useHead(returnObject)
      }

    }
  }
  nuxtApp.provide('headerMethods', headerMethods);
})
